import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Button, Grid, Header } from "semantic-ui-react";

// material
import { Container } from "@mui/material";
import MyTextInput from "../components/common/form/MyTextInput";
import { changeEmailStart } from "../redux/auth/auth.actions";

// components

import DisplayCognitoError from "../components/common/DisplayCognitoError";

// ----------------------------------------------------------------------

export default function AdminEmailChange() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { currentError } = useSelector((state) => state.authReducer);
  const [passwordShown, setPasswordShown] = useState(false);
  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };
  const loginHandle = (values) => {
    const payload = {
      newEmail: values.newEmail,
      password: values.password,
      navigate: navigate,
      redirectPath: "/admin",
    };
    try {
      dispatch(changeEmailStart(payload));
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Container>
      <Grid textAlign="center" verticalAlign="middle">
        <Grid.Column style={{ maxWidth: 450 }}>
          <Header as="h2" color="blue" textAlign="center">
            Changer son email
          </Header>
          <DisplayCognitoError errorMessage={currentError} />
          <Formik
            initialValues={{ newEmail: "", password: "" }}
            validationSchema={Yup.object({
                newEmail: Yup.string()
                .required("Adresse e-mail est un champ obligatoire")
                .email("Le champ e-mail n'est pas valide"),
              password: Yup.string().required(
                "Mot de passe est un champ obligatoire"
              ),
            })}
            onSubmit={loginHandle}
          >
            <Form className="ui form">
              <MyTextInput name="newEmail" placeholder="Nouvelle Adresse e-mail" />

              <div className="ui icon input">
                <MyTextInput
                  name="password"
                  placeholder="Votre mot de passe"
                  type={passwordShown ? "text" : "password"}
                  size="60"
                />
                <i
                  aria-hidden="true"
                  onClick={togglePassword}
                  className="eye link icon"
                ></i>
              </div>
              <Button
                type="submit"
                fluid
                size="large"
                color="blue"
                content="Changer son email"
              />
            </Form>
          </Formik>
        </Grid.Column>
      </Grid>
    </Container>
  );
}
